import { Drawer } from 'flowbite';
import { Controller } from '@hotwired/stimulus';
import { get, patch } from '@rails/request.js';
import { mark_all_as_read_admin_notifications_path } from '../../../javascript/routes';
import Cookies from 'js-cookie';

export default class extends Controller {
  static targets = ['notification', 'form', 'button', 'badge', 'count'];

  connect() {
    if (!this.drawer) {
      this.drawer = new Drawer(this.notificationTarget, {
        placement: 'right',
        backdrop: false,
      });

      document.addEventListener('click', this.handleClickOutside);

      // Check if we have any unread notifications and update the badge accordingly
      if (this.hasCountTarget) {
        const count = parseInt(this.countTarget.textContent, 10) || 0;
        this.updateBadgeVisibility(count);
      }
    }
  }

  disconnect() {
    this.drawer?.destroy();
    document.removeEventListener('click', this.handleClickOutside);
  }

  updateBadgeVisibility(count) {
    if (this.hasBadgeTarget) {
      if (count > 0) {
        this.badgeTarget.classList.remove('hidden');
      } else {
        this.badgeTarget.classList.add('hidden');
      }
    }
  }

  handleClickOutside = (event) => {
    if (
      this.drawer?.isVisible &&
      !this.buttonTarget.contains(event.target) &&
      !this.notificationTarget.contains(event.target)
    ) {
      this.close();
    }
  };

  open() {
    this.drawer.show();
    document.body.classList.remove('overflow-hidden');
  }

  toggle() {
    this.drawer.toggle();
  }

  hide() {
    this.drawer.hide();
    this.drawer.destroy();

    document.querySelectorAll('[drawer-backdrop]').forEach((el) => {
      el.remove();
    });
  }

  close() {
    this.hide();
  }

  async submitForm(event) {
    event.preventDefault();

    const url = new URL(this.formTarget.action);
    const formData = new FormData(this.formTarget);

    formData.forEach((value, key) => {
      Cookies.set(key, value, { expires: 7 });
      url.searchParams.append(key, value);
    });

    await get(url, {
      responseKind: 'turbo-stream',
    });
  }

  async resetForm() {
    this.formTarget.reset();

    const url = new URL(this.formTarget.action);
    await get(url, {
      responseKind: 'turbo-stream',
    });
  }

  async markAllAsRead() {
    try {
      await patch(mark_all_as_read_admin_notifications_path());

      if (this.hasCountTarget) {
        this.countTarget.textContent = '0';
        this.updateBadgeVisibility(0);
      }

      const url = new URL(this.formTarget.action);
      await get(url, {
        responseKind: 'turbo-stream',
      });
    } catch (error) {
      console.error('Failed to mark all as read:', error);
    }
  }
}
